import * as React from 'react';
import { connect } from 'react-redux';
import CurrentToolIcon from '../../header-toolbar/CurrentToolIcon';
import NewToolbarItemScroller from '../../common/toolbar-item-scroller/NewToolbarItemScroller';
import IconButton from '../../common/IconButton';
import UIAction from '../../../actions/ui/UIAction';
import { Dispatch, Action } from 'redux';

interface HeaderToolbarHanderasingLevelProps {
  readonly isVertical: boolean;
  readonly popLevel: () => void;
  readonly popToTopLevel: () => void;
  readonly dispatch: Dispatch<Action>;
}

const HeaderToolbarHanderasingLevel: React.SFC<
  HeaderToolbarHanderasingLevelProps
> = React.memo((props) => {
  const { dispatch, isVertical, popLevel, popToTopLevel } = props;

  return (
    <>
      <CurrentToolIcon />

      <NewToolbarItemScroller vertical={isVertical} alignEnd={false} scrollButtons={true}>
        <IconButton
          title="太さ1"
          imagePath="images/tool-icons/new/eraser_size_01/eraser_size_01"
          onClick={() => { UIAction.setHanderasingWidth(10, dispatch); }} />
        <IconButton
          title="太さ2"
          imagePath="images/tool-icons/new/eraser_size_02/eraser_size_02"
          onClick={() => { UIAction.setHanderasingWidth(20, dispatch); }} />
        <IconButton
          title="太さ3"
          imagePath="images/tool-icons/new/eraser_size_03/eraser_size_03"
          onClick={() => { UIAction.setHanderasingWidth(40, dispatch); }} />
        <IconButton
          title="太さ4"
          imagePath="images/tool-icons/new/eraser_size_04/eraser_size_04"
          onClick={() => { UIAction.setHanderasingWidth(80, dispatch); }} />
        <IconButton
          title="太さ5"
          imagePath="images/tool-icons/new/eraser_size_05/eraser_size_05"
          onClick={() => { UIAction.setHanderasingWidth(160, dispatch); }} />
      </NewToolbarItemScroller>

      <IconButton
        title="戻る"
        imagePath="images/tool-icons/new/btn_return/btn_return"
        rouondRect={true}
        onClick={popLevel} />
      <IconButton
        title="トップ"
        imagePath="images/tool-icons/new/btn_top/btn_top"
        rouondRect={true}
        onClick={popToTopLevel} />
    </>
  );
});

export default connect()(HeaderToolbarHanderasingLevel);
